<template>
  <div class="orderBox">
    <div class="form-title">
      <span>保费优惠及预缴信息</span>
      <!-- <span class="form-title-info">如需续期应缴保费推送准确，以下数据请尽量维护准确</span> -->
    </div>

    <FormItem prop="isPrePay" label="是否预缴" :label-width="140">
      <span v-if="disabled">{{ formData.isPrePay | filterYesOrNo }}</span>
      <RadioGroup v-else v-model="formData.isPrePay">
        <Radio label="1">是</Radio>
        <Radio label="0">否</Radio>
      </RadioGroup>
    </FormItem>
    <FormItem v-if="formData.isPrePay == '1'" prop="policyDiscount.prepaidYears" label="预缴保费年限" :label-width="140">
      <span v-if="isRead">{{ formData.policyDiscount.prepaidYears | filterPrepaidYears }}</span>
    </FormItem>

    <!-- <FormItem v-if="formData.isPrePay == '1'" prop="policyDiscount.prePayRate" label="预缴优惠利率" :label-width="140">
      <span v-if="disabled">{{ formData.policyDiscount.prePayRate }}%</span>
      <Input v-else type="text" v-model="formData.policyDiscount.prePayRate" placeholder="请输入0-100的数字"><span slot="append">%</span></Input>
    </FormItem> -->

    <template v-if="formData.isPrePay == '1'">
      <FormItem
        v-for="(rate, idx) in formData.policyDiscount.prePayRate"
        :key="idx"
        :prop="`policyDiscount.prePayRate[${idx}].rate`"
        :label="`${rate.year * 1 === 1 ? '首' : '第' + rate.year}年预缴优惠利率`"
        :label-width="140"
        :rules="[rateRule]"
      >
        <span v-if="isRead">{{ formData.policyDiscount.prePayRate[idx].rate }}%</span>
        <Input v-else type="text" v-model="formData.policyDiscount.prePayRate[idx].rate" placeholder="请输入0-100的数字"><span slot="append">%</span></Input>
      </FormItem>
    </template>

    <FormItem v-if="formData.isPrePay == '1'" prop="policyDiscount.returnType" label="返还形式" :label-width="140">
      <span v-if="isRead">{{ formData.policyDiscount.returnType | filterReturnType }}</span>
    </FormItem>
    <FormItem prop="policyDiscount.discountType" :label="formData.isPrePay == 1 ? '预缴保费优惠方式' : '保费优惠方式'" :label-width="140">
      <span v-if="disabled">{{ formData.policyDiscount.discountType | filterDiscountType }}</span>
      <RadioGroup v-else v-model="formData.policyDiscount.discountType">
        <Radio label="1">回赠</Radio>
        <Radio label="2">折扣</Radio>
        <Radio label="0">无优惠</Radio>
      </RadioGroup>
    </FormItem>

    <template v-if="[1, 2].includes(formData.policyDiscount.discountType * 1)">
      <FormItem prop="policyDiscount.discountRates[0].rate" label="首年优惠比例" :label-width="140">
        <span v-if="disabled">{{ getRateText(0) }}</span>
        <div v-else class="rate-ipt-box">
          <div v-if="formData.isPrePay == 1" class="discount-rate-return-type">{{ getDiscountRateReturnTypeDesc(0) }}</div>
          <Input type="text" v-model="formData.policyDiscount.discountRates[0].rate" placeholder="请输入0-100的数字"><span slot="append">%</span></Input>
        </div>
      </FormItem>

      <FormItem prop="policyDiscount.discountRates[1].rate" label="第2年优惠比例" :label-width="140">
        <span v-if="disabled">{{ getRateText(1) }}</span>
        <div v-else class="rate-ipt-box">
          <div v-if="formData.isPrePay == 1" class="discount-rate-return-type">{{ getDiscountRateReturnTypeDesc(1) }}</div>
          <Input type="text" v-model="formData.policyDiscount.discountRates[1].rate" placeholder="请输入0-100的数字"><span slot="append">%</span></Input>
        </div>
      </FormItem>

      <FormItem prop="policyDiscount.discountRates[2].rate" label="第3年优惠比例" :label-width="140">
        <span v-if="disabled">{{ getRateText(2) }}</span>
        <div v-else class="rate-ipt-box">
          <div v-if="formData.isPrePay == 1" class="discount-rate-return-type">{{ getDiscountRateReturnTypeDesc(2) }}</div>
          <Input type="text" v-model="formData.policyDiscount.discountRates[2].rate" placeholder="请输入0-100的数字"><span slot="append">%</span></Input>
        </div>
      </FormItem>

      <FormItem prop="policyDiscount.discountRates[3].rate" label="第4年优惠比例" :label-width="140">
        <span v-if="disabled">{{ getRateText(3) }}</span>
        <div v-else class="rate-ipt-box">
          <div v-if="formData.isPrePay == 1" class="discount-rate-return-type">{{ getDiscountRateReturnTypeDesc(3) }}</div>
          <Input type="text" v-model="formData.policyDiscount.discountRates[3].rate" placeholder="请输入0-100的数字"><span slot="append">%</span></Input>
        </div>
      </FormItem>

      <FormItem prop="policyDiscount.discountRates[4].rate" label="第5年优惠比例" :label-width="140">
        <span v-if="disabled">{{ getRateText(4) }}</span>
        <div v-else class="rate-ipt-box">
          <div v-if="formData.isPrePay == 1" class="discount-rate-return-type">{{ getDiscountRateReturnTypeDesc(4) }}</div>
          <Input type="text" v-model="formData.policyDiscount.discountRates[4].rate" placeholder="请输入0-100的数字"><span slot="append">%</span></Input>
        </div>
      </FormItem>
    </template>

    <FormItem prop="policyDiscount.firstPremiumLevy" label="保费征费/年" :label-width="140">
      <span v-if="disabled">{{ formData.policyDiscount.firstPremiumLevy }}</span>
      <Input v-else type="text" v-model="formData.policyDiscount.firstPremiumLevy" placeholder="请输入" />
    </FormItem>

    <FormItem prop="policyDiscount.firstDuePremium" label="首年应缴保费" :label-width="140">
      <span v-if="disabled">{{ formData.policyDiscount.firstDuePremium }}</span>
      <Input v-else type="number" v-model="formData.policyDiscount.firstDuePremium" placeholder="请输入" />
    </FormItem>

    <!-- <FormItem prop="policyDiscount.firstPaidPremium" label="首年实缴保费" :label-width="140">
      <span v-if="disabled">{{ formData.policyDiscount.firstPaidPremium }}</span>
      <Input v-else type="text" v-model="formData.policyDiscount.firstPaidPremium" placeholder="请输入" />
    </FormItem> -->

    <FormItem prop="payStatus" label="新单缴费状态" :label-width="140" :rules="$units.formRule.required('请选择')">
      <lzDicTxt v-if="disabled" :dicCode="formData.payStatus" dicType="POLICY_PAY_STATUS"></lzDicTxt>
      <Select v-else v-model="formData.payStatus" transfer clearable placeholder="请选择" @on-change="onChangePayStatus">
        <Option v-for="(txt, value) in POLICY_PAY_STATUS" :value="value" :key="value">{{ txt }}</Option>
      </Select>
    </FormItem>

    <!-- <FormItem
      v-if="[2, 3, 4].includes(formData.payStatus * 1)"
      prop="payDate"
      key="payDate"
      label="缴费日期"
      :label-width="140"
      :rules="$units.formRule.objRequired('请选择')"
    >
      <DatePicker v-model="formData.payDate" type="date" format="yyyy-MM-dd" transfer placeholder="请选择" />
    </FormItem> -->

    <!-- <FormItem
      v-if="formData.payStatus * 1 === 2"
      prop="submitAccountDate"
      key="submitAccountDate"
      label="提交对账日期"
      :label-width="140"
      :rules="$units.formRule.objRequired('请选择')"
    >
      <DatePicker v-model="formData.submitAccountDate" type="date" format="yyyy-MM-dd" transfer placeholder="请选择" />
    </FormItem> -->

    <FormItem v-if="formData.payStatus * 1 === 4" prop="refundFeeDate" key="refundFeeDate" label="退费日期" :label-width="140">
      <DatePicker v-model="formData.refundFeeDate" type="date" format="yyyy-MM-dd" transfer placeholder="请选择" />
    </FormItem>
  </div>
</template>

<script>
import { common } from '@/api/mixins';
import lzDicTxt from '@/components/commons/lzDicTxt';
import lzDicSelect from '@/components/commons/lzDicSelect';
// import Decimal from 'decimal.js';
import _ from 'lodash';
import mixinChild from '../mixin.child';
import { filter } from 'lodash';
import dayjs from 'dayjs';

const dic = JSON.parse(localStorage.getItem('dic') || '{}');
const POLICY_PAY_STATUS = dic.POLICY_PAY_STATUS;

export default {
  mixins: [common, mixinChild],
  components: {
    lzDicSelect,
    lzDicTxt
  },
  filters: {
    filterReturnType(val) {
      if (val == 1) {
        return '抵扣保费'
      } else if(val == 2) {
        return '存入账户'
      }else{
        return ''
      }
    },
    filterPrepaidYears(val) {
      if (val == 0) {
        return '一笔过'
      } else if (val == 1) {
        return '预缴1年'
      } else if (val == 2) {
        return '预缴2年'
      }else{
        return ''
      }
    },
    filterDiscountType(val) {
      const m = new Map([
        ["1", "回赠"],
        ["2", "折扣"],
        ["0", "无优惠"],
      ]);
      return m.get(val + "");
    }
  },
  props: ['formData', 'disabled'],
  inject: ['parent'],
  data() {
    return {
      POLICY_PAY_STATUS,
      activityList: [],
      activityPlaceholder: '请选择',
      userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),
      prePayRateList: [],
      activity_discountFeeYear: 0, // 折扣抵扣年限
      activity_backFeeYear: 0, // 回赠抵扣年限
    };
  },
  created() { },
  mounted() {
    this.activityChange();
    this.getActivityList();
  },
  methods: {
    onChangePayStatus() {
      this.$set(this.formData.policyDiscount, 'payDate', '');
      this.$set(this.formData.policyDiscount, 'submitAccountDate', '');
      this.$set(this.formData.policyDiscount, 'refundFeeDate', '');
    },
    getActivityList() {
      this.$http({
        url: '/buz/insuranceProductActivity/detail',
        type: 'GET',
        data: {
          productId: this.formData.productId,
          pageSize: 999,
          pageNo: 1
          // status: 1
        }
      }).then(res => {
        this.activityList = res.data;
      });
      this.$http({
        url: '/buz/policy/read/activity',
        type: 'POST',
        data: {
          // 预缴相关信息
          policyDiscount: {
            isPrePay: this.formData.isPrePay,
            prepaidYears: this.formData.policyDiscount.prepaidYears,
          },
          // 保单基本信息
          productId: this.formData.productId,
          companyId: this.formData.companyId,
          paymentPeriod: this.formData.paymentPeriod,
          fee: this.formData.fee,
          currencyType: this.formData.currencyType,
          signDate: dayjs(this.formData.signDate).format('YYYY-MM-DD'),
        }
      }).then(res => {
        const prePayItem = (res.data || []).find(item => item.type == 1)
        if (prePayItem) {
          const n_discountFeeYear = Number(prePayItem.discountFeeYear);
          const n_backFeeYear = Number(prePayItem.backFeeYear);
          if (typeof n_discountFeeYear === "number" && !isNaN(n_discountFeeYear)) {
            this.activity_discountFeeYear = n_discountFeeYear;
          } else {
            this.activity_discountFeeYear = 0;
          }
          if (typeof n_backFeeYear === "number" && !isNaN(n_backFeeYear)) {
            this.activity_backFeeYear = n_backFeeYear;
          } else {
            this.activity_backFeeYear = 0;
          }
        }
      });
    },
    activityChange() {
      this.$http({
        url: '/buz/product/query/list',
        type: 'GET',
        data: { activityId: this.formData.policyDiscount.activityId }
      }).then(res => {
        this.productList = res.data;
      });
    },
    // 解密
    openEye(row, key) {
      if (!row['eyeShow' + key]) {
        this.descrypt(
          {
            query: row.id,
            operationFunction: 3,
            operationType: 3
          },
          row,
          key
        ).then(() => {
          this.$set(row, 'eyeShow' + key, true);
        });
      }
    },
    // 获取利率描述
    getRateText(idx) {
      const policyDiscount = this.formData.policyDiscount;
      const arr = policyDiscount.discountRates;
      const isPrepay = this.formData.isPrePay == 1;
      if (arr[idx].rate) {
        if (isPrepay) {
          return `${arr[idx].rate}% - ${this.getDiscountRateReturnTypeDesc(idx)}`;
        } else {
          return `${arr[idx].rate}%`;
        }
      } else {
        return "";
      }
    },
    // 获取每年的优惠返还类型
    getDiscountRateReturnTypeDesc(idx) {
      const policyDiscount = this.formData.policyDiscount;
      // isPrePay 是否预缴
      const pp = this.formData.isPrePay;
      // 数字类型 isPrePay
      const n_pp = Number(pp);
      if (n_pp === 0 || isNaN(n_pp)) {
        return "-";
      }
      // discountType 优惠返还类型
      const dt = policyDiscount.discountType;
      // 数字类型 discountType
      const n_dt = Number(dt);
      let prefix = "";
      if (this.isRead) {
        prefix = "预缴";
      }
      // 使用回赠年限或者折扣年限判断，超超过这个年限的一律为存入账户
      if (n_dt === 1) {
        // 回赠
        const year = Number(this.activity_backFeeYear);
        if (idx + 1 > year) {
          return prefix + "存入账户";
        } else {
          return prefix + "抵扣保费";
        }
      } else if (n_dt === 2) {
        // 折扣
        const year = Number(this.activity_discountFeeYear);
        if (idx + 1 > year) {
          return prefix + "存入账户";
        } else {
          return prefix + "抵扣保费";
        }
      } else {
        return "-";
      }
    },
  }
};
</script>
<style lang="scss" scoped>
.autoCalc__btn {
  margin-left: 10px;
  color: #236dff;
  cursor: pointer;
}
.rate-ipt-box {
  display: flex;

  .discount-rate-return-type {
    padding: 0 10px;
    flex: 0 0 80px;
  }
}
</style>
